import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { SharePrivateContentPermissionToggle } from "~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle";
import { SharePermissionSection } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePermissionSection";
export const ShareVersionsPermissions = /*#__PURE__*/ memo((param)=>{
    let { onPermissionUpdated, shortIdInfo, isLoading } = param;
    return /*#__PURE__*/ _jsx(SharePermissionSection, {
        title: "Versions",
        children: /*#__PURE__*/ _jsx(SharePrivateContentPermissionToggle, {
            label: "Show versions",
            id: "canViewAllVersions",
            isLoading: isLoading,
            checked: shortIdInfo.permissions.asset.canViewAllVersions,
            onCheckedChange: (checked)=>onPermissionUpdated({
                    asset: {
                        canViewAllVersions: checked
                    }
                })
        })
    });
});
ShareVersionsPermissions.displayName = "ShareViewerPermissions";
